import { render, staticRenderFns } from "./area.vue?vue&type=template&id=c52304be&"
import script from "./area.vue?vue&type=script&lang=js&"
export * from "./area.vue?vue&type=script&lang=js&"
import style0 from "./area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports